import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
const StepFive = ({ setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Social Security Information</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Social Security Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Social Security Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Consent for Social Security Verification:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Consent for Social Security Verification" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(3)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(5)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepFive;
